import { MenuModes, MenuEntriesService, MenuActions } from './../../../../providers/menu-entries.service';
import { Component, ViewChild } from '@angular/core';
import { Loading, LoadingController, Navbar, NavController, NavParams, Platform, ModalController, Menu, App, ToastController } from 'ionic-angular';
import { EventDetailsModel, EventProvider } from '../../../../providers/event/event';
import { SharingProvider } from '../../../../providers/sharing/sharing';
import { ConfigProvider } from '../../../../providers/config/config';
import { Observable, Observer } from 'rxjs';
import { SessionProvider } from '../../../../providers/session/session';
import { StrackerProvider, EventRegistrationModel } from '../../../../providers/stracker/stracker';
import { NewsController } from '../../../../providers/news/news-contoller';
import { AppDetectorProvider } from '../../../../providers/detector/detector';
import { SocialSharing } from '@ionic-native/social-sharing';
import { Base64ToGallery, Base64ToGalleryOptions } from '@ionic-native/base64-to-gallery';
import { Transfer, TransferObject } from '@ionic-native/transfer';
import { Instagram } from '@ionic-native/instagram';
import { Camera } from '@ionic-native/camera';
import { ScreenRotatable } from '../../../../providers/screen-rotatable/screen-rotatable';
import { ScreenRotatableService } from '../../../../providers/screen-rotatable/screen-rotatable.service';
import { MysportResultsMenuPage } from '../../../me/mysport/mysport-results/mysport-results-menu/mysport-relults-menu';
import { PaymentService } from '../../../../providers/payment.service';
import { TranslateService } from '@ngx-translate/core';
import { GeolocationService } from '../../../../providers/geolocation-service/geolocation-service';
import { NearbyMapPage } from '../../../nearby/main/nearby-main';
import { QRCodePage } from '../../../me/qrcode/qrcode';
import { Calendar } from '@ionic-native/calendar';
import { LoginPage } from '../../../login/login/login';
import { AdsProvider } from '../../../../providers/ads/ads';
import { timer } from 'rxjs/observable/timer';
declare var cordova;

/**
 * Generated class for the EventTabsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-event-tabs',
  templateUrl: 'event-tabs.html'
})
export class EventTabsPage {

  @ViewChild(Navbar) navBar: Navbar;

  detailPage: string = "details";
  event: EventDetailsModel | any;
  dateFormatted: any;
  bdValues: number[];
  finalDate;
  registered: boolean = true;

  //clientSpecific is needed for lauftreff app
  clientSpecific: boolean = false;
  instance;
  totalPrice: number = 0;
  eventPrice: number = 0;
  hasPayment: boolean = false;
  currency: string;
  redirect: boolean = false;
  hasOldDesign: boolean = false;
  actionSub = null;
  isPremium: boolean = false;
  isPremiumEvent:boolean=false;
  sponsors = null;
  activeSponsor = 0;

  constructor(public navCtrl: NavController,
    private appDetector: AppDetectorProvider,
    private strackerService: StrackerProvider,
    private sessionService: SessionProvider,
    private eventService: EventProvider,
    private navParams: NavParams,
    private camera: Camera,
    private instagram: Instagram,
    private platform: Platform,
    private base64ToGallery: Base64ToGallery,
    private paymentService: PaymentService,
    private transfer: Transfer,
    private sharer: SocialSharing,
    private modalCtrl: ModalController,
    private config: ConfigProvider,
    private screen: ScreenRotatableService,
    private menuService: MenuEntriesService,
    private loadingCtrl: LoadingController,
    private translate: TranslateService,
    private geoService: GeolocationService,
    private app:App,
    private toastCtrl: ToastController,
    private calendar: Calendar,
    private ads: AdsProvider) {
    console.log("event-tabs.ts constructor()");
    this.isPremium = Boolean(JSON.parse(localStorage.getItem('premium'))) || false;
    this.event = this.navParams.get("event");
    this.isPremiumEvent = this.event.premium;
    this.redirect = this.navParams.get("redirect");
    if (this.redirect) {
      this.currency = this.navParams.get("currency");
      this.totalPrice = this.navParams.get("amount");
      this.eventPrice = this.totalPrice;
      this.detailPage = "payment";
      this.hasPayment = true;
    }
    this.dateFormatted = this.navParams.get("dateFormatted");
    new Promise(async (resolve, reject) => {
      console.log(this.event);
      this.clientSpecific = (await this.config.config).showHide.lauftreff;
      this.hasOldDesign = (this.appDetector.isForestApp() || this.appDetector.isHellaApp()) ? true : false;
      // this.detailPage = this.appDetector.isForestApp() ? this.detailPage + "-shop" : this.detailPage;
    });

    this.instance = this;
    // this.actionSub = this.menuService.actionSub.subscribe((action: MenuActions) => {
    //   this.actionPerform(action);
    // })
    // if(this.isPremiumEvent && appDetector.isEventsApp()){
    //   this.ads.getSponsorAds().then(r => {
    //     this.sponsors = r;
    //     this.sponsorAds();
    //   });
    // }else if(appDetector.isEventsApp() && !this.isPremium){
    //   this.ads.initAds()
    // }
  }

  sponsorAds() {
    if (!this.sponsors) return;
    let repeat = 0;

    timer(0, 9900).subscribe(async () => {
      let element = document.getElementById('sponsor-ads');
      if (element) {
        element.setAttribute('class', 'sponsor-' + (repeat + 1));
      }
      repeat = (repeat + 1) % (await this.config.config).ads.numberOfAds;
      this.activeSponsor = (this.activeSponsor + 1) % this.sponsors.length;
    });
    // timer(0, 9900).subscribe(async () => {
    //   this.activeSponsor = (this.activeSponsor + 1) % this.sponsors.length;
    // });
  }

  public isLoged(): boolean {
    return this.sessionService.isLoged;
  }

  public profileImage(): string {
    return this.sessionService.profile.profilePicLink || 'assets/imgs/default-image-32@1x.png';
  }

  ngOnInit() {
    this.bdValues = this.string2Bin(this.event.booleanData);
  }

  ionViewDidLoad() {
    this.setBackButtonAction();
    if(this.isPremiumEvent && this.appDetector.isEventsApp()){
      this.ads.getSponsorAds().then(r => {
        this.sponsors = r;
        this.sponsorAds();
      });
    }else if(this.appDetector.isEventsApp() && !this.isPremium){
      this.ads.initAds()
      if(this.platform.is('ios')){
        this.ads.show()
      }
    }
  }

  onDetailsClick() {
    console.log('details');
    this.detailPage = "details-shop";
  }

  onMyDataClick() {
    console.log('person-information');
    this.detailPage = "person-information";
  }

  onPaymentClick() {
    console.log('payment');
    this.detailPage = "payment";
  }

  //Method to override the default back button action
  setBackButtonAction() {
    this.navBar.backButtonClick = () => {
      if (this.hasPaymentSystem()) {
        if (this.detailPage === "payment") {
          this.detailPage = "person-information";
        } else if (this.detailPage === "person-information") {
          this.detailPage = "details-shop";
        } else {
          this.navCtrl.pop();
        }
      } else {
        this.navCtrl.pop();
      }
    }
  }

  string2Bin(str: string): number[] {
    var result = [];
    for (var i = 0; i < str.length; i++) {
      let binaryChar = str.charCodeAt(i).toString(2);
      for (let z = 0; z < 8; z++) {
        result.push(parseInt(binaryChar.charAt(z) || "0"));
      }
    }
    return result;
  }

  canDisplayInfoPage(): boolean {
    let is = this.bdValues.indexOf(1) !== -1 ||
      this.event.presentCeremony !== -1 ||
      this.event.lateRegistration !== -1;
    return is;
  }


  share() {
    let loader = this.loadingCtrl.create({});
    loader.present();
    this.sharer.shareViaFacebook('', null, "https://spooorts.de/ui/showEvent.jsf?cid=" + this.event.cid + "&id=" + this.event.id).then(() => {
      loader.dismiss();
    }).catch(err => {
      console.error('err: ', err);
      loader.dismiss();
    });
  }

  ionViewWillLeave() {
    NewsController.getInstance().isAllowed = true;
    this.lockPortraitOrientation();
    if (this.actionSub) { this.actionSub.unsubscribe(); this.actionSub = null; }
  }

  lockPortraitOrientation() {
    this.screen.lockPortraitOrientation();
  }

  shareInstagram() {
    var loader = this.loadingCtrl.create();
    loader.present();
    this.getBase64ImageFromURL(this.event.images[0].imageLink).subscribe(base64data => {
      console.log(base64data);
      let base64Image = 'data:image/jpeg;base64,' + base64data;
      if (this.platform.is('ios')) {
       this.convertToImage(base64data);
        loader.dismiss();
        this.sharer.shareViaInstagram("", base64Image).then(() => {
          console.log('The image is shared via Instagram!');
        }).catch(err => {
          console.log(err);
          console.log('The image was not shared via Instagram!');
        });
      } else {
        this.instagram.share(base64Image);
        this.sharer.shareViaInstagram("", base64Image).then(() => {
          console.log('The image is shared via Instagram!');
        }).catch(err => {
          console.log(err);
          console.log('The image was not shared via Instagram!');
        });
        loader.dismiss();
      }
    });
  }

  convertToImage(image) {
    let config: Base64ToGalleryOptions = {
      prefix: 'img_',
      mediaScanner: true
    };

    this.base64ToGallery.base64ToGallery(image, config).then(
      res => {
        this.downloadFile(image);
      },
      err => console.log('Error saving image to gallery ', err)
    );
  }

  showMenu() {
    const modal = this.modalCtrl.create(MysportResultsMenuPage, { mode: MenuModes.EVENT_DETAILS });
    modal.onDidDismiss(option => {
      this.menuService.actionSub.next(option);
      this.actionPerform(option)
    })
    modal.present();
  }

  actionPerform(menuAction: MenuActions) {
    switch (menuAction) {
      case MenuActions.SHOW_MAP: this.openMap(); break;
      case MenuActions.QR_SCAN: this.generateQrCode(); break;
      case MenuActions.EVENT_MARK: this.markEventwithRedirect(); break;
      case MenuActions.ADD_CALENDAR: this.onAddCalendar(); break;
      case MenuActions.INSTA_SHARE: this.shareInstagram(); break;
      case MenuActions.FB_SHARE: this.shareFacebook(); break;
    }
  }

  onAddCalendar() {
    console.log(new Date(this.event.date));
    this.calendar.createEvent(this.event.name, this.event.place, "", new Date(this.event.date), new Date(this.event.date));
  }
  toastMessage(message, duration, position = "bottom") {
    this.toastCtrl.create({
      message: message,
      duration: duration,
      position: position
    }).present();
  }
  markEventwithRedirect(){
    if (!this.sessionService.isLoged) {
      new Promise<any>((resolve, reject) => {
        (this.app.getRootNav() as NavController).push(LoginPage, { resolve: resolve });
      }).then((status) => {
        if (status) {
          this.sessionService.getToken(false, false).then((token) => {
            (token) ? this.markEvent() : this.toastMessage(this.translate.instant('LOGIN_HAVE_TO_LOGIN'), 5000);
          });
        }
      })
      } else {
        this.sessionService.getToken().then((token) => {
          (token) ? this.markEvent() : this.toastMessage(this.translate.instant('LOGIN_HAVE_TO_LOGIN'), 5000);
        });
      }
  }

  markEvent(){
    this.eventService.addToFavorit(this.event.id).then(succ => {
      if (succ) {
        this.toastCtrl
          .create({
            message: this.translate.instant('EVENT_ADDED_TOAST'),
            duration: 2000
          })
          .present();
      } else {
        this.toastCtrl
          .create({
            message: this.translate.instant('EVENT_ADD_FAILED_TOAST'),
            duration: 2000
          })
          .present();
        }
      });
  }

  generateQrCode(){
    this.sessionService.getToken().then(token => {
      this.eventService.getQRCode(token, this.event.id).then(qrcode => {
        if(this.appDetector.isLeaderBoardApp() || this.appDetector.isTournamentApp()){
          this.navCtrl.push(QRCodePage, { qrcode: qrcode.content });
        }else{
          (this.app.getActiveNav() as NavController).push(QRCodePage, { qrcode: qrcode.content });
        }
      });
    });
  }

  openMap(){
      let loading = this.loadingCtrl.create({
        content: this.translate.instant('GLOBAL_LOADING')
      });
      this.geoService.activeId = this.event.id;
      this.geoService.setupPlugin().then(() => { });
      //  this.nearbyMainResolver.doResolve([this.event], config).then(data => {
      this.event.participants = [];
      this.event.evtInfosList = [];
      this.event.mode = null;
      this.event.timeInfos = 0;
      let events = {
        nearbyEvents: [this.event],
        mapState: null,
        selectedIndex: 0,
        trackLocation: false
      }
      loading.dismiss();
      (this.app.getRootNav() as NavController).push(NearbyMapPage, { events: events });
  }

  shareFacebook() {
    let loader = this.loadingCtrl.create({});
    loader.present();
    if(this.platform.is('android')){
      this.sharer.shareVia('com.facebook.katana', 'My message', this.event.images[0].imageLink, "https://spooorts.de/ui/showEvent.jsf?cid=" + this.event.cid + "&id=" + this.event.id).then(() => {
        loader.dismiss();
      }).catch(err => {
        console.error('err: ', err);
        loader.dismiss();
      });
    }else{
      this.sharer.shareViaFacebook('message', 'message', "https://spooorts.de/ui/showEvent.jsf?cid=" + this.event.cid + "&id=" + this.event.id).then(() => {
        loader.dismiss();
      }).catch(err => {
        console.error('err: ', err);
        loader.dismiss();
      });
    }
  }

  downloadFile(imageLink) {
    let that = this;
    this.platform.ready().then(() => {

      const fileTransfer: TransferObject = this.transfer.create();

      let storageDirectory = "";

      const imageLocation = this.event.images[0].imageLink;

      if (this.platform.is('ios')) {
        storageDirectory = cordova.file.documentsDirectory;
      }
      else if (this.platform.is('android')) {
        storageDirectory = cordova.file.dataDirectory;
      }

      let image = imageLocation + ".jpeg";

      console.log('storageDirectory: ', storageDirectory);
      fileTransfer.download(imageLocation, storageDirectory + image).then((entry) => {
        console.log('entry: ', entry.toURL());
        this.instagram.shareAsset(entry.toURL()).then(() => {
          console.log('succes INSTAGRAM');
        });
      }, (error) => {
        console.log(error);
      });
    });
  }

  isRegistered() {
    return new Promise<any>((resolve, reject) => {
      this.strackerService.checkForExistance('event-registration').then(exist => {
        if (!exist) { resolve(false); return; }
        this.strackerService.getSaved('event-registration').then((data: EventRegistrationModel[]) => {
          data.forEach(f => {
            if (f.id == this.sessionService.profile.id && f.eventId == this.event.id)
              resolve(true);
          });
          resolve(false);
        });
      });
    });
  }

  public async hasPaymentSystem() {
    const isEventsBrowser = (this.appDetector.isEventsApp() && ((await this.config.config).platform.browser)) ? true : false;
    return (this.appDetector.isForestApp() || this.appDetector.isSpooortsApp() || isEventsBrowser);
  }

  public async enablePayment() {
    this.hasPayment = await this.hasPaymentSystem();
  }

  public disablePayment() {
    this.hasPayment = false;
  }

  onPostFB() {
    // let base64Image = "";
    // this.getBase64ImageFromURL(this.registration.imageLink).subscribe(base64data => {
    //   base64Image = 'data:image/jpeg;base64,' + base64data;
    //   this.sharingService.shareFacebook('test', base64Image);
    // });
  }

  getBase64ImageFromURL(url: string) {
    return Observable.create((observer: Observer<string>) => {
      let img = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = url;
      if (!img.complete) {
        img.onload = () => {
          observer.next(this.getBase64Image(img));
          observer.complete();
        };
        img.onerror = (err) => {
          observer.error(err);
        };
      } else {
        observer.next(this.getBase64Image(img));
        observer.complete();
      }
    });
  }

  getBase64Image(img: HTMLImageElement) {
    var canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    var dataURL = canvas.toDataURL("image/png");
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
  }

  ngOnDestroy() {
    console.log('destroy');
    this.paymentService.clearPaymentAttempt();
    // if(this.platform.is('ios')){
      if(this.appDetector.isEventsApp()) this.ads.hide();
    // }
  }
}



// WEBPACK FOOTER //
// /src/pages/event/details/event-tabs/event-tabs.ts